import { Table as AntdTable, Empty } from "antd";
import type { TableProps } from "antd";

const defaultLocale = {
  emptyText: (
    <Empty
      description="Geen items gevonden."
      style={{ backgroundColor: "white", margin: "-8px -16px", padding: "8px" }}
    />
  ),
  triggerAsc: "Klik om oplopend te sorteren.",
  triggerDesc: "Klik om aflopend te sorteren.",
  cancelSort: "Klik om sortering te annuleren.",
};

// Combintation of root variables and styling because of lack of support for css variables in antd table component
export const Table = <T extends object = object>({
  locale = defaultLocale,
  ...props
}: TableProps<T>) => {
  return (
    <AntdTable
      locale={{ ...locale }}
      styles={{
        header: {
          cell: {
            paddingTop: "16px",
            paddingBottom: "16px",
          },
        },

        section: {
          border: props?.size === "small" ? "none" : "1px solid #e9e9e9",
          borderRadius: props?.size === "small" ? 0 : "16px",
          borderBottom: "1px solid #eee",
          overflow: "hidden",
          backgroundColor: "#ffffff",
          color: "#333333",
        },
        body: {
          wrapper: {
            overflow: "hidden",
            borderRadius: "16px",
          },
          cell: {
            "--ant-color-bg-container": "#ffffff",
            color: "#555",
          } as React.CSSProperties,
        },
      }}
      {...props}
    />
  );
};
